//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AfterEventCancellationDeadlineAction, CancellationConversionPolicy, BeforeEventCancellationDeadlineAction } from './Enums';

export class SchoolEventPolicyCancellationDeadlineSettingsDisplayItem extends ItemBase {
    AfterCancellationDeadlineAction: AfterEventCancellationDeadlineAction = AfterEventCancellationDeadlineAction.AbsentMakeup;
    AfterCancellationDeadlineConvertAction: CancellationConversionPolicy = CancellationConversionPolicy.None;
    BeforeCancellationDeadlineAction: BeforeEventCancellationDeadlineAction = BeforeEventCancellationDeadlineAction.AbsentMakeup;
    BeforeCancellationDeadlineConvertAction: CancellationConversionPolicy = CancellationConversionPolicy.None;
    CreateNotification: boolean = false;
    HoursUntilDeadline: number = 0;

    constructor(initializer?: Partial<SchoolEventPolicyCancellationDeadlineSettingsDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolEventPolicyCancellationDeadlineSettingsDisplayItem";
}
